
<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Remover imobiliária"
      message="Você tem certeza que deseja deletar essa imobiliária?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="realEstates"
        :options.sync="options"
        :server-items-length="total"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhuma imobiliária encontrada"
        :footer-props=" {
          showFirstLastPage: true,
          'items-per-page-text': 'registros por página',
          'items-per-page-options': optionsPage,
          pageText: '{0}-{1} de {2}'
        }"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Imobiliárias</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Nova Imobiliária
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="realEstate.name"
                            :rules="requiredRules"
                            label="Nome"
                            maxlength="100"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-mask="'XX.XXX.XXX/XXXX-##'"
                            v-model="realEstate.cnpj"
                            :rules="cnpjRules"
                            label="CNPJ"
                            required
                            @keyup="uppercase"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                          v-model="realEstate.properties"
                            :items="properties"
                            no-data-text="Sem dados"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ maxHeight: '400' }"
                            label="Empreendimentos"
                            multiple
                            hint="Selecione os empreendimentos"
                            persistent-hint
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!valid" text @click="validate">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogImport" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green"
                  dark
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Importar
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Importar imobiliárias</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="formImport"
                      v-model="validImport"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                          v-model="fileImport.properties"
                            :items="properties"
                            no-data-text="Sem dados"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ maxHeight: '400' }"
                            :rules="requiredMultipleRules"
                            label="Empreendimentos"
                            multiple
                            hint="Selecione os empreendimentos"
                            persistent-hint
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-file-input
                            class="mr-2 mt-2"
                            v-model="fileImport.file"
                            label="Excel de importação (.xlsx)"
                            hint="Selecione o arquivo de importação"
                            :rules="fileRules"
                            accept=".xlsx"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="closeImport">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!validImport" text @click="validateImport">Importar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-btn v-if="isAdmin" color="green" dark class="mb-2 mr-2" v-on:click="exportExcel">
              Exportar
            </v-btn>
          </v-toolbar>

          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  label="Nome"
                  v-model="filters.name"
                />
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="green" class="btn-filter" text @click="filterRealStates">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="red" class="btn-filter" text @click="clearFilters">Limpar Filtros</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="edit(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            small
            @click="openConfirmModal(item)"
          >
            mdi-delete-empty
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2"></div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'
import store from '@/store'
import { isCNPJ } from 'brazilian-values'
import jsonxlsx from 'json-as-xlsx'
import xlsx from 'xlsx'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    optionsPage: [10, 25, 50, 100],
    confirmModal: false,
    hasSure: false,
    itemToDelete: null,
    dialog: false,
    dialogImport: false,
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    validImport: true,
    requiredRules: [
      v => !!v || 'Informação obrigatória'
    ],
    requiredMultipleRules: [
      v => v.length !== 0 || 'Informação obrigatória'
    ],
    fileRules: [
      v => !!v || 'Arquivo obrigatório',
      v => !v || v.name.endsWith('.xlsx') || 'Arquivo deve ser do tipo .xlsx'
    ],
    cnpjRules: [
      v => !!v || 'Informação obrigatória',
      v => isCNPJ(v) || 'CNPJ deve ser válido'
    ],
    headers: [
      { text: 'Nome', align: 'start', value: 'name' },
      { text: 'CNPJ', value: 'cnpj' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    realEstates: [],
    properties: [],
    editedIndex: -1,
    editedId: false,
    realEstate: {
      id: null,
      name: null,
      cnpj: null,
      properties: []
    },
    defaultItem: {
      id: null,
      name: null,
      cnpj: null,
      properties: []
    },
    filters: {
      name: null
    },
    fileImport: {
      file: null,
      properties: []
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Imobiliária' : 'Editar Imobiliária'
    },
    modeCreate () {
      return this.editedIndex === -1
    },
    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    }
  },

  watch: {
    options: {
      handler () {
        this.getRealStates()
      },
      deep: true
    },
    dialog (val) {
      val || this.close()
    },
    dialogImport (val) {
      val || this.closeImport()
    }
  },

  created () {
    this.getRealStates()
    this.getProperties()
  },

  methods: {
    async getRealStates () {
      try {
        this.loading = true

        let url = `/real-states?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}`
        if (this.filters.name) url += `&name=${this.filters.name}`

        const { data } = await api.get(url)

        this.realEstates = data.data
        this.total = Number(data.total)
      } catch (error) {
        message.error('Erro ao buscar imobiliárias')
      } finally {
        this.loading = false
      }
    },

    filterRealStates () {
      this.options.page = 1
      this.getRealStates()
    },

    clearFilters () {
      this.filters.name = null
      this.options.page = 1
      this.getRealStates()
    },

    async getProperties () {
      try {
        const { data } = await api.get('/properties')
        this.properties = data
      } catch (error) {
        message.error('Erro ao buscar Empreendimentos')
      } finally {
        this.loading = false
      }
    },

    uppercase () {
      this.realEstate.cnpj = this.realEstate.cnpj ? this.realEstate.cnpj.toUpperCase() : null
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    validateImport () {
      if (this.$refs.formImport.validate()) {
        try {
          let fileReader = new FileReader()

          fileReader.readAsBinaryString(this.fileImport.file)

          fileReader.onload = (event) => {
            let data = event.target.result
            let workbook = xlsx.read(data, { type: 'binary' })

            workbook.SheetNames.forEach((sheet) => {
              let rows = xlsx.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
              let hasError = false

              for (let row of rows) {
                if (row.name === undefined || row.cnpj === undefined) {
                  message.error('Imobiliária com informações incompletas. Verifique o arquivo de importação')
                  hasError = true
                  break
                }
                if (row.manager_name !== undefined && (row.manager_email === undefined || row.manager_cell === undefined || row.manager_password === undefined)) {
                  message.error('Imobiliária "' + row.name + '" com Gerente incompleto. Verifique o arquivo de importação')
                  hasError = true
                  break
                }

                if (row.cnpj) row.cnpj = row.cnpj.toString().toUpperCase()
                if (row.manager_cell) row.manager_cell = row.manager_cell.toString()
                if (row.manager_password) row.manager_password = row.manager_password.toString()
              }

              if (hasError) return

              this.createRealStatesLot(rows)
            })
          }
        } catch (error) {
          message.error('Erro ao ler Excel para realizar o upload')
        }
      }
    },

    async createRealStatesLot (realStates) {
      try {
        this.loadingMessage = 'Carregando'
        this.loading = true
        message.warning('Em execução', 'Imobiliárias sendo importadas')

        await api.post('/real-states/lots', {
          realStates,
          properties: this.fileImport.properties
        })

        message.success('Imobiliárias importadas')
        this.loading = false
        this.closeImport()
        await this.getRealStates()
      } catch (error) {
        this.loading = false
        this.closeImport()
        message.error(error.message)
      }
    },

    async exportExcel () {
      try {
        const { data } = await api.get(`/real-states?page=-1&itemsPerPage=-1`)

        const dataExcel = [{
          sheet: 'Lista',
          columns: [
            { label: 'Nome', value: 'name' },
            { label: 'CNPJ', value: row => row.cnpj ? row.cnpj : '' }
          ],
          content: data.data
        }]

        const settings = {
          fileName: 'Imobiliárias',
          extraLength: 3,
          writeOptions: {}
        }

        jsonxlsx(dataExcel, settings)
      } catch (error) {
        message.error(error.message)
      }
    },

    async edit (item) {
      this.loadingMessage = 'Carregando'
      this.loading = true
      this.editItemToTable(item)
      this.loading = false
    },

    editItemToTable (item) {
      this.editedIndex = this.realEstates.indexOf(item)
      this.editedId = item.id
      this.realEstate = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem () {
      if (this.hasSure) {
        this.loadingMessage = 'Removendo'
        this.loading = true

        try {
          await api.delete(`/real-states/${this.itemToDelete.id}`)
          message.success('Imobiliária removida')
          this.removeToTable(this.itemToDelete)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    openConfirmModal (item) {
      this.itemToDelete = item
      this.confirmModal = true
    },

    handleCancelConfirmModal () {
      this.hasSure = false
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.hasSure = true
      this.confirmModal = false
      this.deleteItem()
    },

    removeToTable (item) {
      const index = this.realEstates.indexOf(item)
      this.realEstates.splice(index, 1)
    },

    close () {
      this.$refs.form.reset()
      this.valid = true
      this.dialog = false
      this.$nextTick(() => {
        this.realEstate = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeImport () {
      this.$refs.formImport.reset()
      this.validImport = true
      this.dialogImport = false
      this.$nextTick(() => {
        this.fileImport = Object.assign({}, {
          file: null,
          properties: []
        })
      })
    },

    async save () {
      let data = {
        name: this.realEstate.name ? this.realEstate.name : null,
        cnpj: this.realEstate.cnpj ? this.realEstate.cnpj.toUpperCase() : null,
        properties: this.realEstate.properties
      }

      this.loading = true

      if (this.editedIndex === -1) {
        this.loadingMessage = 'Salvando'

        try {
          const response = await api.post('/real-states', data)
          message.success('Imobiliária salva')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      } else {
        this.loadingMessage = 'Atualizando'

        try {
          const response = await api.put(`/real-states/${this.editedId}`, data)
          message.success('Imobiliária atualizada')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    addToTable (item) {
      if (this.editedIndex > -1) {
        Object.assign(this.realEstates[this.editedIndex], this.realEstate)
      } else {
        this.realEstates.push(item)
      }
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/realStates/RealStates.vue